
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30497","data-name":"Group 30497","transform":"translate(-729 -334.997)"}},[_c('g',{attrs:{"id":"Group_30496","data-name":"Group 30496","transform":"translate(-38 121.997)"}},[_c('g',{attrs:{"id":"Main_Data_type_date","data-name":"Main Data type date","transform":"translate(665.849 -326.148)"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(101.151 539.148)","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_30494","data-name":"Group 30494","transform":"translate(728.286 337.85)"}},[_c('g',{attrs:{"id":"Group_30495","data-name":"Group 30495","transform":"translate(1.6 .466)","fill":"none","stroke":"#96a0ae","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}},[_c('line',{attrs:{"id":"Line_887","data-name":"Line 887","y1":"7.107","x2":"2.534","transform":"rotate(-7 4.517 -32.398)"}}),_c('path',{attrs:{"id":"Path_21039","data-name":"Path 21039","d":"M3.274 1.188L.6 4.095 3.274 7","transform":"translate(-.6 -.413)"}}),_c('path',{attrs:{"id":"Path_21040","data-name":"Path 21040","d":"M12.106 7l2.67-2.907-2.67-2.906","transform":"translate(-2.548 -.413)"}})])])])])
          )
        }
      }
    